import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import reportWebVitals from './reportWebVitals';
import { MetamaskStateProvider } from "use-metamask";
import { BrowserRouter } from 'react-router-dom'
import Routes from './Routes'

ReactDOM.render(
  <React.StrictMode>
     <MetamaskStateProvider> 
      <BrowserRouter>
       <Routes />
      </BrowserRouter>
    </MetamaskStateProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
